import { render, staticRenderFns } from "./financeHandoverDoc.vue?vue&type=template&id=717d5432&scoped=true&"
import script from "./financeHandoverDoc.vue?vue&type=script&lang=js&"
export * from "./financeHandoverDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717d5432",
  null
  
)

export default component.exports